export default __webpack_public_path__ + "static/media/background_image_blue.f8c3af85.png";